String.prototype.includes||(String.prototype.includes=function(t,n){return"number"!=typeof n&&(n=0),!(n+t.length>this.length)&&-1!==this.indexOf(t,n)});



//////////////////
// WEBPACK FOOTER
// ./node_modules/mdn-polyfills/String.prototype.includes.js
// module id = 420
// module chunks = 1